import script from "./LeaderProjectFormStep1.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectFormStep1.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectFormStep1.vue?vue&type=style&index=0&id=56e4f781&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56e4f781"]])

export default __exports__